import React from 'react';
import { getPageNumbers } from '../../utils/pagination';

// Discrete page navigation for the results list. Controlled: the parent owns the
// current page and the from/to/total range; this component only renders and emits
// page-change requests. Renders nothing when there is a single page.
export function Pagination({ currentPage, pageCount, from, to, total, onPageChange, className = '' }) {
  if (!pageCount || pageCount <= 1) return null;

  const pages = getPageNumbers(currentPage, pageCount);
  const goTo = (page) => {
    if (page < 1 || page > pageCount || page === currentPage) return;
    onPageChange(page);
  };

  const navBtn =
    'inline-flex items-center justify-center min-w-8 h-8 px-2 rounded-md text-sm font-medium transition-colors disabled:opacity-40 disabled:cursor-not-allowed';

  return (
    <nav
      className={`flex flex-col sm:flex-row items-center justify-between gap-2 ${className}`}
      aria-label="Seitennavigation"
    >
      <div className="text-xs text-slate-500 dark:text-slate-400">
        Zeige <span className="font-medium text-slate-700 dark:text-slate-200">{from}</span>–
        <span className="font-medium text-slate-700 dark:text-slate-200">{to}</span> von{' '}
        <span className="font-medium text-slate-700 dark:text-slate-200">{total}</span>
      </div>

      <div className="flex items-center gap-1">
        <button
          type="button"
          className={`${navBtn} text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700`}
          onClick={() => goTo(currentPage - 1)}
          disabled={currentPage <= 1}
          aria-label="Vorherige Seite"
        >
          «
        </button>

        {pages.map((page) =>
          typeof page === 'string' ? (
            <span key={page} className="px-1 text-slate-400 dark:text-slate-500 select-none">
              …
            </span>
          ) : (
            <button
              key={page}
              type="button"
              className={`${navBtn} ${
                page === currentPage
                  ? 'bg-green-600 text-white'
                  : 'text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700'
              }`}
              onClick={() => goTo(page)}
              aria-label={`Seite ${page}`}
              aria-current={page === currentPage ? 'page' : undefined}
            >
              {page}
            </button>
          )
        )}

        <button
          type="button"
          className={`${navBtn} text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700`}
          onClick={() => goTo(currentPage + 1)}
          disabled={currentPage >= pageCount}
          aria-label="Nächste Seite"
        >
          »
        </button>
      </div>
    </nav>
  );
}
